import React from "react";
import { IoIosAddCircleOutline } from "react-icons/io";
const AddMember = ({ buttonName, onClick }) => {
  return (
    <div>
      <button
        onClick={onClick}
        className="flex  items-center justify-center min-w-[10rem] gap-2 space-x-2  ml-2 text-white  bg-[#FF6B00]  py-2 px-5 rounded-lg"
      >
        <IoIosAddCircleOutline />
        {buttonName}
      </button>
    </div>
  );
};
export default AddMember;
